import React from 'react';
import { useLocation } from 'react-router-dom';
import { CircleDot, Flag, Music, PawPrint } from 'lucide-react';
import AppLink from './AppLink';
import { useLanguage } from '../context/LanguageContext';

const TABS = [
  { href: '/our-flag', icon: Flag, label: { en: 'Our Flag', bn: 'আমাদের পতাকা' } },
  { href: '/our-tiger', icon: PawPrint, label: { en: 'Our Tiger', bn: 'আমাদের বাঘ' } },
  { href: '/theme-song', icon: Music, label: { en: 'Theme Song', bn: 'থিম সং' } },
  { href: '/our-roundel', icon: CircleDot, label: { en: 'Our Roundel', bn: 'বৃত্ত-প্রতীক' } },
];

export const SymbolsTabs = ({ dark = false }) => {
  const { t } = useLanguage();
  const { pathname } = useLocation();
  return (
    <div className={`inline-flex max-w-full flex-wrap justify-center rounded-full p-1 ${dark ? 'bg-white/10 border border-white/20' : 'bg-white border border-gray-200 shadow-sm'}`} data-testid="symbols-tabs">
      {TABS.map(({ href, icon: Icon, label }) => {
        const active = pathname === href;
        return (
          <AppLink key={href} to={href} data-testid={`symbols-tab-${href.slice(1)}`}
            className={`flex items-center gap-2 rounded-full px-3 py-2 text-sm sm:px-4 font-semibold transition-colors ${active ? 'bg-party-red text-white' : dark ? 'text-white/80 hover:text-white' : 'text-gray-600 hover:text-party-red'}`}>
            <Icon className="h-4 w-4" />{t(label)}
          </AppLink>
        );
      })}
    </div>
  );
};
